import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import Map from "../components/Contact/MapContent";
import BaseLayout from "../components/global/BaseLayout";
import ContactInfo from "../components/Contact/ContactInfo2";

function Contact() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="Contact">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="Contact"
          Subheader="Contact"
          bgimg={`${rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[16] : rpdata?.stock?.[4]}`}
        />
        <ContactInfo
        image1={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[8] : rpdata?.stock?.[4]}
        image={rpdata?.gallery?.length > 20 ? rpdata?.gallery?.[25] : rpdata?.stock?.[4]}
        />
        <Map />
      </div>
    </BaseLayout>
  );
}

export default Contact;
